import React from 'react';
import { Tag } from '@blueprintjs/core';

import { MultiSelect } from '@f/components/shared/select';
import { StartingMaterialDatasetItem } from '@f/services/starting-material/starting-material.types';

import cls from '../SearchParameterForm.module.scss';

import { Checkbutton } from './checkbutton/Checkbutton';

export interface SupplierItem {
  id: string | number;
  name: string;
}

export interface DatasetInputItem extends StartingMaterialDatasetItem {
  supplierItems?: SupplierItem[];
  value: boolean | string[];
}

interface DatasetInputProps {
  datasetInputItem: DatasetInputItem;
  onChange: (nextValue: boolean | SupplierItem[]) => void;
  disabled?: boolean;
}

export function DatasetInput(props: DatasetInputProps) {
  const { datasetInputItem, onChange, disabled = false } = props;

  const { id, name, supplierItems, value } = datasetInputItem;

  if (typeof value === 'boolean') {
    return (
      <Checkbutton
        large
        outlined
        disabled={disabled}
        text={name}
        value={value}
        onChange={onChange}
        data-test={`dataset-checkbox-${id}`}
        data-cy={`dataset-checkbox-${id}`}
      />
    );
  }

  return (
    <MultiSelect
      large
      outlined
      enableSelectAll
      enableSelectNone
      items={supplierItems}
      selectedItemIds={value}
      idField="id"
      disabled={disabled}
      labelField="name"
      buttonProps={(activeItems: any[], items: any[]) => {
        return {
          className: cls.materialSupplierButton,
          text: (
            <>
              <Tag className={cls[`${id}Tag`]} round minimal>
                {`${activeItems.length}/${items.length}`}
              </Tag>
              {` ${name}`}
            </>
          ),
        };
      }}
      onChange={onChange}
      data-test={`supplier-multiselect-${id}`}
      key={id}
    />
  );
}
